import React, { useEffect, useState } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import {
  ExcelExport,
  ExcelExportColumn,
  ExcelExportColumnGroup,
} from "@progress/kendo-react-excel-export";
import {
  IntlProvider,
  LocalizationProvider,
  loadMessages,
} from "@progress/kendo-react-intl";
import Messages from "../../common/kendo-react-messages/QuestionMessage.json";
import { process as dataProcess } from "@progress/kendo-data-query";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy } from "@progress/kendo-data-query";
import { Error } from "../../common/Error";
import { GetToken } from "../../common/getToken";
import AnalyticsQuestionModel from "./AnalyticsQuestionModel";
import { IoReaderOutline } from "react-icons/io5";
import axios from "axios";
import moment from "moment";
import { SiMicrosoftexcel } from "react-icons/si";
import {
  ExcelSurveyStartLabel,
  ExcelSurveyEndLabel,
  ExcelSurveyStartDate,
  ExcelSurveyEndDate,
} from "../../common/DateFormat";
loadMessages(Messages, "en-US-Questions");

const AllQuestionsGrid = ({ overview, surveyDetails }) => {
  /* get REACT_APP_API_URL from .env file */
  const { REACT_APP_API_URL } = process.env;
  const [modalShow, setModalShow] = useState(false);
  const [modalQuestion, setModalQuestion] = useState([]);
  const [questionNo, setQuestionNo] = useState([]);

  const modalQuestionData = async (Question, Id) => {
    await axios
      .get(`${REACT_APP_API_URL}/getQuestionAnalyticsById/${Id}`, {
        headers: {
          authorization: GetToken(),
        },
      })
      .then((result) => {
        if (result.data.code === 200) {
          if (result.data.message !== "") {
            Error(404, result.data.message);
          } else {
            setQuestionNo(Question);
            setModalQuestion(result.data.data[0]);
            setModalShow(true);
          }
        }
      })
      .catch((err) => {
        if (err.response) {
          Error(err.response.status, err.response.data.message);
        } else if (err.request) {
          Error(err.request.status, err.request.data.message);
        } else {
          Error(404, "Something went wrong.");
        }
      });
  };

  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
  });

  // const [currentLocale, setCurrentLocale] = useState(locales[0]);
  const [dataResult, setDataResult] = useState();

  useEffect(() => {
    setDataResult(dataProcess(overview, dataState));
  }, [overview, dataState]);

  const dataStateChange = (event) => {
    setDataResult(dataProcess(overview, event.dataState));
    setDataState(event.dataState);
  };

  let _export;
  const exportExcel = () => {
    const options = _export.workbookOptions();

    options.sheets[0].frozenRows = "0";
    const headerRow = {
      cells: [
        // Opened on

        {
          value: ExcelSurveyStartLabel(surveyDetails.StartDate),
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        {
          value: ExcelSurveyStartDate(surveyDetails.StartDate),
          color: "#000",
          background: "#eee",
          fontSize: 16,
        },

        // Respondents
        {
          value: "Total Respondents",
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        {
          value: surveyDetails.uniqueUsers,
          color: "#000",
          background: "#eee",
          fontSize: 16,
        },
      ],
    };

    const headerRowNext = {
      cells: [
        // Closes on
        {
          value: ExcelSurveyEndLabel(surveyDetails.ExpiryDate),
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        {
          value: ExcelSurveyEndDate(surveyDetails.ExpiryDate),
          color: "#000",
          background: "#eee",
          fontSize: 16,
        },

        // Questions
        {
          value: "Total Questions",
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        {
          value: surveyDetails.totalQuestions,
          color: "#000",
          background: "#eee",
          fontSize: 16,
        },
      ],
    };

    const headerRowThird = {
      cells: [
        // Downloaded on
        {
          value: "Downloaded On",
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        {
          value: moment().format("MM/DD/YYYY h:mm A"),
          color: "#000",
          background: "#eee",
          fontSize: 16,
        },

        // Responses
        {
          value: "Total Responses",
          color: "#000",
          background: "#eee",
          bold: true,
          fontSize: 16,
        },
        {
          value: surveyDetails.totalquestionResponses,
          color: "#000",
          background: "#eee",
          fontSize: 16,
        },
      ],
    };

    const headerRowFourth = {
      cells: [
        // Downloaded on
        { value: " ", background: "#fff" },
        { value: " ", background: "#fff" },

        // Responses
        { value: " ", background: "#fff" },
      ],
    };

    const headerRowFive = {
      cells: [
        // Downloaded on
        {
          value: surveyDetails.SurveyName + " By " + surveyDetails.CompanyName,
          color: "#ffffff",
          background: "#32c5ff",
          bold: true,
          fontSize: 15,
          textAlign: "center",
          colSpan: "3",
        },
      ],
    };

    // const headerRowSix = {
    //   cells: [
    //     // Downloaded on
    //     { value: " " },
    //     { value: " " },

    //     // Responses
    //     { value: " " },
    //     { value: " " },
    //   ],
    // };

    // const footerRow = {
    //   cells: [{ value: `Powered by` }, { value: "OpenEyes Technologies Inc.", URL: "https://theopeneyes.com/" }],
    // };

    const rows = options.sheets[0].rows;

    // rows.unshift(headerRowSix);
    rows.unshift(headerRowFive);
    rows.unshift(headerRowFourth);
    rows.unshift(headerRowThird);
    rows.unshift(headerRowNext);
    rows.unshift(headerRow);

    // rows.push(footerRow);

    _export.save(options);
  };

  const filterData = (e) => {
    let value = e.target.value;
    let filter = {
      logic: "or",
      filters: [
        // { field: "Question", operator: "contains", value: value },
        { field: "QuestionText", operator: "contains", value: value },
        // { field: "totalquestionResponses", operator: "contains", value: value },
      ],
    };
    setDataResult(filterBy(overview, filter));
  };

  const checkPageable = (dataLength) => {
    if (dataLength < 5) {
      return false;
    } else {
      return {
        buttonCount: 4,
        pageSizes: [5, 10, 20, 50, 100],
        pageSize: 5,
      };
    }
  };

  //Function For The Remove Dot From The SurveyName And Replace With UnderScore
  const fileName = (() => {
    const surveyName = surveyDetails.SurveyName.trim();
    if (surveyName !== "") {
      const sanitizedSurveyName = surveyName
        .split(" ")
        .join("")
        .replace(/\.+/g, "")
        .replace(/\s+/g, "-");
      console.log(sanitizedSurveyName, "SanitizeNaame");
      const formattedDate = moment().format("MM-DD-YYYY-hh-mm");
      if (sanitizedSurveyName.charAt(sanitizedSurveyName.length - 1) === ".") {
        return sanitizedSurveyName.slice(0, -1) + "_Overview_" + formattedDate;
      } else {
        return sanitizedSurveyName + "_Overview_" + formattedDate;
      }
    } else {
      return "Survey-Overview-" + moment().format("MM-DD-YYYY-hh-mm");
    }
  })();

  return (
    <>
      {overview.length > 0 ? (
        <Row>
          <Col lg={12}>
            <div class="graph_scroll_head mt-4">
              Scroll sideways to view complete table
            </div>

            <div className="chart-table custom-respo my-5">
              {/* <LocalizationProvider language={currentLocale.language}>
                <IntlProvider locale={currentLocale.locale}> */}
              <LocalizationProvider language="en-US-Questions">
                <IntlProvider locale="message">
                  <ExcelExport
                    data={overview}
                    fileName={fileName}
                    ref={(exporter) => {
                      _export = exporter;
                    }}
                  >
                    <ExcelExportColumnGroup
                      title=""
                      headerCellOptions={{
                        background: "#fff",
                        color: "#ffffff",
                        bold: true,
                        textAlign: "center",
                      }}
                    >
                      <ExcelExportColumn
                        field="Question"
                        title="#"
                        width={125}
                        headerCellOptions={{
                          background: "#eee",
                          color: "#000",
                          bold: true,
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                      />
                      <ExcelExportColumn
                        field="QuestionText"
                        title="Question"
                        headerCellOptions={{
                          bold: true,
                          background: "#eee",
                          color: "#000",
                        }}
                      />
                      <ExcelExportColumn
                        field="totalquestionResponses"
                        title="Number of Responses"
                        headerCellOptions={{
                          bold: true,
                          textAlign: "right",
                          color: "#000",
                          background: "#eee",
                        }}
                        cellOptions={{
                          textAlign: "right",
                        }}
                      />
                    </ExcelExportColumnGroup>
                  </ExcelExport>

                  <Grid
                    sortable={true}
                    filterable={false}
                    groupable={false}
                    // reorderable={true}
                    pageable={checkPageable(overview.length)}
                    data={dataResult}
                    {...dataState}
                    onDataStateChange={dataStateChange}
                    // expandField="expanded"
                    // onExpandChange={expandChange}
                    // resizable={true}
                  >
                    <GridToolbar>
                      <Input
                        onChange={filterData}
                        placeholder="Search question"
                      />
                      <button
                        className="save-pdf export-btn"
                        title="Export Excel"
                        onClick={exportExcel}
                      >
                        <SiMicrosoftexcel />
                      </button>
                    </GridToolbar>
                    <GridColumn
                      field="Question"
                      title="#"
                      width="50px"
                      className="text-center"
                      headerClassName="text-center"
                      // locked={true}
                    />
                    <GridColumn
                      field="QuestionText"
                      title="Question"
                      width="500px"
                    />
                    <GridColumn
                      field="totalquestionResponses"
                      title="Number of Responses"
                      headerClassName="text-end"
                      width="170px"
                      className="text-end"
                    />
                    <GridColumn
                      title="Detail"
                      headerClassName="text-center"
                      cell={(props) => (
                        <td>
                          <div className="print-from-grid-button text-center">
                            <Button
                              variant="primary"
                              onClick={() => {
                                modalQuestionData(
                                  props.dataItem.Question,
                                  props.dataItem.QuestionId
                                );
                              }}
                              className="save-pdf"
                            >
                              <IoReaderOutline />
                            </Button>
                          </div>
                        </td>
                      )}
                      width="90px"
                    />
                  </Grid>
                </IntlProvider>
              </LocalizationProvider>
            </div>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={12} className="text-center mt-5">
            <p className="text-danger mt-5">No questions found</p>
          </Col>
        </Row>
      )}
      <AnalyticsQuestionModel
        show={modalShow}
        modalQuestion={modalQuestion}
        questionNo={questionNo}
        surveyDetails={surveyDetails}
        handleClose={() => setModalShow(false)}
      />
    </>
  );
};

export default AllQuestionsGrid;
